module.exports = __webpack_public_path__ + "img/ogre.fd8196a0.jpg";